// Testing permission fix - version bump should now push successfully
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import store from './Store/index.store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom'
import Main from './Main';
import './I18n'
//! Entra
// import msalInstance from './authConfigure';
// import { MsalProvider } from "@azure/msal-react";

if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(function (registration) {
      console.log('Registration successful, scope is:', registration.scope);
    })
    .catch(function (err) {
      console.log('Service worker registration failed, error:', err);
    });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {/* 
    //! Entra
    <MsalProvider instance={msalInstance}> */}
      <BrowserRouter>
        <Provider store={store}>
            <Main />
        </Provider>
      </BrowserRouter>
    {/* </MsalProvider> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
